import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Organization, organizationDecoder } from '../models/organization';
import { HttpService, HttpServiceBuilder } from '../util/http.service';
import { SingletonEntityService } from '../util/singleton-entity.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationsService extends SingletonEntityService<Organization> {
  private webhookSigningKeyHttpService: HttpService<{}, Organization>;

  constructor(
    orgHttpServiceBuilder: HttpServiceBuilder<Organization>,
    wskHttpServiceBuilder: HttpServiceBuilder<{}, Organization>
  ) {
    super(orgHttpServiceBuilder, 'organization', organizationDecoder);

    this.webhookSigningKeyHttpService = wskHttpServiceBuilder.build({
      route: 'organization/webhook_signing_key',
      decoder: organizationDecoder,
      encoder: (entity: {}) => entity,
    });
  }

  clearWebhookSigningKey(): Observable<boolean> {
    return this.webhookSigningKeyHttpService.deleteSingleton();
  }

  regenerateWebhookSigningKey(): Observable<Organization> {
    return this.webhookSigningKeyHttpService.create({});
  }

  setPrimaryLocation(locationId: string): Observable<Organization> {
    // Use the httpService from the parent class with a custom config
    const config = {
      ...this.httpService.getConfig(),
      route: 'organization/set_primary_location',
    };
    // Create a temporary organization object with the location_id to send
    const payload = { location_id: locationId } as any;
    return this.httpService.updateSingleton(payload, config);
  }
}
